module.exports = "import React from 'react';\n\nimport Spinner from '../src';\n\nexport default () => <Spinner interactionName=\"load\" />;\n"